import { Icon, IconType } from "../../icons/Icon";
import styles from "./AppConfirmDialog.module.scss";
import {
  confirmDialog,
  ConfirmDialog,
  ConfirmDialogOptions,
} from "primereact/confirmdialog";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import { RenderWhen } from "../../infrastructure/components/RenderWhen";
import React from "react";
import { dialogTransitionOptions } from "../AppDialog/dialogTransition";

export type AppConfirmType = "warning" | "success";

interface IAppConfirmDialogProps {}

export const AppConfirmDialog = ({}: IAppConfirmDialogProps) => {
  // Same open and close animation as every AppDialog.
  return <ConfirmDialog transitionOptions={dialogTransitionOptions} />;
};

export const showCustomConfirmDialog = (
  message: string | JSX.Element,
  accept?: () => void,
  reject?: () => void,
  type: AppConfirmType = "warning",
  mainBtnLabel = "Да",
  rejectBtnLabel: string | null = "Не"
) => {
  const iconType =
    type === "warning"
      ? IconType.Warning
      : type === "success"
      ? IconType.CheckmarkSentIcon
      : IconType.Warning;

  const color =
    type === "warning" ? "#E0BF00" : type === "success" ? "#0EAD69" : "#E0BF00";

  const onClick = (options: ConfirmDialogOptions) => {
    accept?.();
    options.accept();
  };

  return confirmDialog({
    className: styles.root,
    message: (
      <div className={styles.content}>
        <Icon height="60px" width="60px" color={color} type={iconType} />
        <div className={styles.content_message}>
          {React.isValidElement(message) ? (
            message
          ) : (
            <span dangerouslySetInnerHTML={{ __html: message as string }} />
          )}
        </div>
      </div>
    ),
    dismissableMask: true,
    showHeader: false,
    footer: (options) => (
      <div className={styles.footer}>
        <DefaultButton
          className={styles.footer_buttons_button}
          onClick={() => onClick(options)}
          design="default"
          label={mainBtnLabel}
        />
        <RenderWhen condition={!!rejectBtnLabel}>
          <DefaultButton
            className={styles.footer_buttons_button}
            onClick={() => {
              reject?.();
              options.reject();
            }}
            design="outline"
            label={rejectBtnLabel || ""}
          />
        </RenderWhen>
      </div>
    ),
  });
};
